
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Sehr wichtig. Erstens, weil erhöhtes Gewicht mit häufigeren Kopfschmerzen
einhergeht und Sport bei der Gewichtsabnahme hilft. Zweitens, weil er –
vernünftig betrieben – entspannend auf das Nervensystem wirkt und Stresshormone
abbaut. Migräniker sollten aber nicht grad voll loslegen, weil das einen
Schmerzanfall verursachen kann, sondern sich erst gut aufwärmen.
Ausdauersportarten sind zu empfehlen, Sprintsportarten nicht. Ideale Startzeit
ist zwischen 16 und 18 Uhr, am besten drei- bis viermal pro Woche, für jeweils
mindestens 30 Minuten, möglichst im Freien und bei jeder Witterung.
Gewichtsabnahme ohne Sport, allein mit Diät, hilft bei Übergewicht, aber nicht
gegen die Migräne.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;